<template>
  <div class="check" :class="{'done' : formatDone}">
    <i class="mdi mdi-check-box-outline mdi-18px"></i>
    <p>
      {{done}}/{{total}}
    </p>
  </div>
</template>

<script>
export default {
  name: "check",

  props: {
    total : {
      type: Number,
      required: true
    },
    done: {
      type: Number,
      required: true
    }
  },

  computed : {
    formatDone(){
      return this.total === this.done ;
    }
  }
}
</script>

<style scoped>

</style>